<div class="header">
    <div class="app-sidebar__toggle">
        <a class="open-toggle"  (click)="toggleOpenClass()">
            <svg width="20.001" height="19" viewBox="0 0 20.001 19">
                <path id="menu-btn" d="M2157.5,3082a1.5,1.5,0,1,1,0-3h17a1.5,1.5,0,1,1,0,3Zm0-8a1.5,1.5,0,1,1,0-3h17a1.5,1.5,0,1,1,0,3Zm0-8a1.5,1.5,0,0,1,0-3h17a1.5,1.5,0,0,1,0,3Z" transform="translate(-2156 -3063)" fill="#446475"/>
            </svg>
        </a>
    </div>
    <div class="logo-mobile">
        <img height="35" src="./assets/images/logo/collapse-logo.svg" alt="">
    </div>
    <div class="header-app-btns d-flex align-items-center justify-content-between">
        <div class="search-bar d-none">
            <div class="search-mop" (click)="toggleSearchBar()">
                <svg width="20" height="20" viewBox="0 0 20 20">
                    <path id="search-btn" d="M7.453,0a7.263,7.263,0,0,1,5.255,2.172,7.405,7.405,0,0,1,2.145,5.282A7.518,7.518,0,0,1,14.4,10.08a6.854,6.854,0,0,1-1.314,2.2l.322.322h.912L20,18.284,18.284,20,12.6,14.316V13.4l-.322-.322a6.854,6.854,0,0,1-2.2,1.314,7.518,7.518,0,0,1-2.627.456,7.405,7.405,0,0,1-5.282-2.145A7.263,7.263,0,0,1,0,7.453,7.415,7.415,0,0,1,7.453,0Zm0,2.306a5.131,5.131,0,0,0-3.646,1.5A4.943,4.943,0,0,0,2.359,7.453a4.95,4.95,0,0,0,5.094,5.094,4.95,4.95,0,0,0,5.094-5.094A4.943,4.943,0,0,0,11.1,3.807,5.131,5.131,0,0,0,7.453,2.306Z" fill="#446475"/>
                </svg>
            </div>
            <form action="" [ngClass]="{'animated-height': shouldShow}">
                <input class="search-input" type="search" id="Search" name="Search" placeholder="Search...">
            </form>
        </div>

        <div class="header-part2 d-flex align-items-center ml-auto">
            <a (click)="changeLanguage()" class="mr-4 lange-btn">{{ 'general.language' | translate }}</a>
            <div class="notification-btn">
                <span (click)="openNotificationPanel()">
                    <span class="notification-count">{{ notificationsResult.unSeenNotificationsCount }}</span>
                    <svg [ngClass]="{swing: notificationsResult.unSeenNotificationsCount}" width="17" height="20" viewBox="0 0 17 20">
                        <path id="notifications-icon" d="M1.152,3.07a2.057,2.057,0,0,0,1.491-.578A2.109,2.109,0,0,0,3.29,1.046H-.985A2.109,2.109,0,0,0-.339,2.492,2.057,2.057,0,0,0,1.152,3.07ZM7.515-3.1V-8.207a7.038,7.038,0,0,0-1.243-4.169,5.932,5.932,0,0,0-3.529-2.337v-.723A1.42,1.42,0,0,0,2.3-16.5a1.575,1.575,0,0,0-1.143-.434A1.575,1.575,0,0,0,.009-16.5a1.42,1.42,0,0,0-.447,1.06v.723A5.971,5.971,0,0,0-3.968-12.4,7.01,7.01,0,0,0-5.21-8.207V-3.1L-7.348-1.026V-.014h17V-1.026Z" transform="translate(7.348 16.93)" fill="#fff"/>
                    </svg>
                </span>
                <div class="notification-panel" [ngClass]="{active: notificationMenu}">
                  <div class="notification-header">
                      <h3>{{ 'general.Notification' | translate }}<span class="loading black" *ngIf="notifLoading"></span></h3>
                  </div>
                  <div class="no-data text-center px-2 py-5"
                      *ngIf="!notificationsList.length && !notifLoading">{{ 'general.You have no notification!' | translate }}</div>
                  <div class="notification-list"
                      *ngIf="notificationsList.length"
                      infiniteScroll
                      [scrollWindow]="false"
                      [infiniteScrollDistance]="2"
                      [infiniteScrollThrottle]="pageCount"
                      (scrolled)="getNextPage()">
                      <div *ngFor="let notif of notificationsList"
                          [ngClass]="{new: !notif.isSeen}"
                          (click)="notificationMenu = false; refreshAllDetails(notif.notificationType)">
                          <a *ngIf="notif.notificationType === 1"
                              [routerLink]="['/admin/messages']"
                              [queryParams]="{message:  notif.notificationObjectId }">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                          <a *ngIf="notif.notificationType === 2"
                              [routerLink]="['/admin/managtracks']">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                          <a *ngIf="notif.notificationType === 3"
                              [routerLink]="['/admin/tasks']"
                              [queryParams]="{ task:  notif.notificationObjectId, type: 0, tabType: notif.notificationTap }">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                          <a *ngIf="notif.notificationType === 4"
                              [routerLink]="['/admin/tasks']"
                              [queryParams]="{ task:  notif.notificationObjectId, type: 1, tabType: notif.notificationTap }">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                          <a *ngIf="notif.notificationType === 7"
                              [routerLink]="['/admin/managegroups/groupdetails', notif.notificationObjectId]">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                          <a *ngIf="notif.notificationType === 8 || notif.notificationType === 9"
                              [routerLink]="['/admin/meetings/', notif.notificationObjectId]">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                          <a *ngIf="notif.notificationType === 10"
                              [routerLink]="['/admin/userdetails/', notif.notificationObjectId]">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                          <a *ngIf="notif.notificationType === 11"
                              [routerLink]="['/admin/voting', notif.notificationObjectId]">
                              <ng-container [ngTemplateOutlet]="notifContent" [ngTemplateOutletContext]='{notif}'></ng-container>
                          </a>
                      </div>
                  </div>

                  <div class="dataLoading" *ngIf="notifLoading && !notificationsList.length">
                    <mat-spinner class="m-auto" diameter="50"></mat-spinner>
                  </div>
                </div>
            </div>
            <span class="loading black ml-3" *ngIf="logoutLoading"></span>
            <div class="userAccount" id="userAccountDrop" [class.offline]='currentUser.userAvailability == 0' (click)="userMenu = !userMenu; notificationMenu = false;">
                <div class="profile-image">
                    <img *ngIf="currentUser.profilePicture" [src]="currentUser.profilePicture" (error)="currentUser.profilePicture = ''" />
                    <span *ngIf="!currentUser.profilePicture">{{ currentUser.name | shortName }}</span>
                </div>
                <div class="user-name">
                    <span class="mr-2"> {{ 'general.Hello' | translate }}, {{currentUser.name}}</span>
                    <svg *ngIf="!userMenu" width="8" height="5" viewBox="0 0 8 5">
                        <path id="arrow-down" d="M-2.313-6.729.75-3.627l3.063-3.1.937.949-4,4.051-4-4.051Z" transform="translate(3.25 6.729)" fill="#999"/>
                    </svg>
                    <svg *ngIf="userMenu" width="8" height="5" viewBox="0 0 8 5">
                        <path id="arrow-down" d="M-2.313-1.729.75-4.83l3.063,3.1.937-.949-4-4.051-4,4.051Z" transform="translate(3.25 6.729)" fill="#999"/>
                    </svg>
                </div>

                <div class="custom-dropdown-menu" [ngClass]='{"active": userMenu}'>
                    <ul>
                        <li><a [routerLink]="['/admin/myprofile']">
                            <svg width="14" height="17" viewBox="0 0 14 17">
                                <path id="my-profile-icon" d="M7,8.5a12.35,12.35,0,0,1,5,1c1.3.6,2,1.4,2,2.4v1.7H0V11.9A2.954,2.954,0,0,1,2,9.5,12.35,12.35,0,0,1,7,8.5ZM2.6,15.3H4.4V17H2.6ZM7,0A3.74,3.74,0,0,1,9.5,1a2.965,2.965,0,0,1,1,2.4,2.965,2.965,0,0,1-1,2.4A3.74,3.74,0,0,1,7,6.8a3.317,3.317,0,0,1-2.5-1,3.1,3.1,0,0,1-1-2.4A2.965,2.965,0,0,1,4.5,1,3.74,3.74,0,0,1,7,0ZM6.1,15.3H7.8V17H6.1Zm3.5,0h1.8V17H9.6Z" fill="#999999"/>
                            </svg>{{ 'general.EditProfile' | translate }}
                        </a></li>
                        <li><a (click)="logout()">
                            <svg width="17.001" height="17.006" viewBox="0 0 17.001 17.006">
                                <path id="logout-icon" d="M6223.19,12103h-13.4a1.815,1.815,0,0,1-1.8-1.808v-13.383a1.815,1.815,0,0,1,1.811-1.808h13.4a1.817,1.817,0,0,1,1.792,1.808v4.146l-1.659-1.559v-2.74h-13.687v13.575h13.687v-2.625l1.659-1.461v4.165a1.766,1.766,0,0,1-.529,1.267,1.69,1.69,0,0,1-1.123.43C6223.3,12103.006,6223.243,12103,6223.19,12103Zm-4.514-5.039,2.691-2.688h-9.562v-1.54h9.562l-2.691-2.691,1.167-1.169,4.52,4.629-4.52,4.629Z" transform="translate(-6208 -12086)" fill="#999"/>
                            </svg>{{ 'general.SignOut' | translate }}
                        </a></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
    <!-- Invoke New Message Event {{notificationNumber}} -->
</div>
<div id="popOverlay" *ngIf="userMenu || notificationMenu"></div>

<ng-template #notifContent let-notif="notif">
  <p class="title">{{notif.notificationText}}</p>
  <span class="date">{{notif.notificationDate | timeAgo}}</span>
</ng-template>
